module.exports = __webpack_public_path__ + "static/ritual_caster-e1bec9e980d00e76b836390839a2c9a4.jpg";